import React, { useEffect, useState } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import axios from "../../../Hook/utils/constants/server";
import useSearchParamsState from "../../../Hook/useSearchparamsstate";
import Backdrop from "@mui/material/Backdrop";
import Loading from "../../../Hook/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./index.scss";
import Tablelist from "../../../Hook/list";
import { Calendar } from "react-calendar";
import { useNavigate } from "react-router-dom";
import GridList from "./gridModal";
import { Button, Alert } from "react-bootstrap";
import { Input } from "@mui/material";


const getInitialWidgets = (appName) => {
  switch (appName) {
    case "Wishlist Guru":
      return [
        {
          widgettype: "Wishlist Users",
          subheading: "Total number of wishlist users",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Wishlist Items",
          subheading: "Total number of wishlist items",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Total Revenue",
          subheading:
            "Items added to the cart from the app is the total revenue",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Monthly Quota Used",
          subheading: "Monthly quota usage",
          dataSet: { wishlistItems: 0, totalQuota: 0, percentUsed: 0 },
        },
      ];

    case "Quotes Guru":
      return [
        {
          widgettype: "Total Quotes",
          subheading: "Has total Quotes",
          dataSet: { count: 0 },
        },

        {
          widgettype: "This Month Quotes",
          subheading: "Total number of quotes created",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Monthly Quota",
          subheading: "Monthly Quota is used",
          dataSet: {
            percentUsed: 0,
          },
        },
      ];

    case "Gift-registry Guru":
      return [
        {
          widgettype: "Total Registries",
          subheading: "Total number of gift registries",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Total Registry Items",
          subheading: "Total number of items across all registries",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Monthly Quota",
          subheading: "Monthly quota usage",
          dataSet: { percentUsed: 0 },
        },
      ];
      
    case "Lock Guru":
      return [
        {
          widgettype: "Total Locks",
          subheading: "Total number of locks created",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Active Locks",
          subheading: "Locks with active status",
          dataSet: { count: 0 },
        },
        {
          widgettype: "Passcode Locks",
          subheading: "Locks protected with a passcode",
          dataSet: { count: 0 },
        },
      ];

    default:
      return [];
  }
};
const StoreDetail = () => {
  const [searchParamsState, setSearchParamsState] = useSearchParamsState();
  const navigate = useNavigate();
  const location = useLocation();
  const [finalUrl, setFinalUrl] = useState("");
  const [stepNumber, setStepNumber] = useState("");
  const [shopifyPlan, setShopifyPlan] = useState("");
  const [updatingPlan, setUpdatingPlan] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    variant: "",
    message: "",
  });
  const [emailLimit, setEmailLimit] = useState("");
  const [updatingEmailLimit, setUpdatingEmailLimit] = useState(false);
  const [review, setReview] = useState("no");
  const [updatingReview, setUpdatingReview] = useState(false);
  const appName = window.localStorage.getItem("activeApp")
    ? window.localStorage.getItem("activeApp")
    : "Wishlist Guru";
  const [stateGroup, setStategroup] = useState({
    loader: false,
    storeDetail: {},
    store_logs: [],
    dates: {
      showCalender: false,
      dates:
        searchParamsState.get("start_date") || searchParamsState.get("end_date")
          ? [
              searchParamsState.get("start_date"),
              searchParamsState.get("end_date"),
            ]
          : ["", ""],
    },
  });
  const positive = useOutletContext();
  const [tableData, setTabledata] = useState({
    thead: [
      {
        type: "text",
        title: "App Install Id",
        key: "app_install_id",
      },
      {
        type: "text",
        title: "Log Id",
        key: "log_id",
      },
      {
        type: "text",
        title: "Plan Name",
        key: "plan_name",
      },
      {
        type: "text",
        title: "Plan Type",
        key: "plan_type",
      },
      {
        type: "text",
        title: "Date",
        key: "log_date",
      },
    ],
    tbody: [],
  });
  // const [analyticsWidget, setAnalyticswidget] = useState([
  //     {
  //         widgettype: "Wishlist Users",
  //         subheading: "Total number of wishlist users",
  //         dataSet: {
  //             count: 0
  //         }
  //     },
  //     {
  //         widgettype: "Wishlist Items",
  //         subheading: "Total number of wishlist items",
  //         dataSet: {
  //             count: 0
  //         }
  //     },
  //     {
  //         widgettype: 'Total Revenue',
  //         subheading: "Items added to the cart from the app is the total reveue",
  //         dataSet: {
  //             count: 0
  //         }
  //     },
  //     {
  //         widgettype: "Monthly Quota Used",
  //         subheading: "monthly quota is used",
  //         dataSet: {
  //             wishlistItems: 0,
  //             totalQuota: 0,
  //             percentUsed: 0
  //         }
  //     }
  // ]);

  const [analyticsWidget, setAnalyticswidget] = useState(() =>
    getInitialWidgets(appName)
  );

  //  useEffect(() => {
  //     setAnalyticswidget(getInitialWidgets(appName));
  //   }, [appName]);


  const fetchStoreDetail = async (params) => {
    const { id, start_, end_ } = params;
    const appName = window.localStorage.getItem("activeApp")
      ? window.localStorage.getItem("activeApp")
      : "Wishlist Guru";
    const response = await axios.get("/user/storedetails", {
      method: "GET",
      params: {
        app_install_id: id,
        start_: start_,
        end_: end_,
      },
      headers: {
        "Content-Type": "application/json",
        "x-app-name": appName,
      },
    });

    return response;
  };
  // const modifyData = (data) => {
  //   let modifiedData = data.map((key, index) => ({
  //     app_install_id: key.app_install_id,
  //     plan_name: key.plan_name,
  //     plan_type: key.plan_type,
  //     log_date: `${new Date(key.log_date).getFullYear()}-${
  //       new Date(key.log_date).getMonth() + 1
  //     }-${new Date(
  //       key.log_date
  //     ).getDate()} ${new Date().getHours()}-${new Date().getMinutes()}-${new Date().getSeconds()} ${new Date(
  //       key.log_date
  //     ).getMilliseconds()}`,
  //     log_id: key.log_id,
  //   }));
  //   return modifiedData;
  // };
    const modifyData = (data) => {
    let modifiedData = data.map((key, index) => {
      const dateObj = new Date(key.log_date);
      
      // Date object se specific parts extract karein
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const day = dateObj.getDate();
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes();
      const seconds = dateObj.getSeconds();

      return {
        app_install_id: key.app_install_id,
        plan_name: key.plan_name,
        plan_type: key.plan_type,
        // Yahan sahi variables use karein
        log_date: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
        log_id: key.log_id,
      };
    });
    return modifiedData;
  };
  const babaji = (e) => {
    stateGroup.dates.dates.some((date) => date.length > 0) &&
      setSearchParamsState({
        start_date: stateGroup.dates.dates.map(
          (date) =>
            `${new Date(date).getFullYear()}-${
              new Date(date).getMonth() + 1
            }-${new Date(date).getDate()}`
        )[0],
        end_date: stateGroup.dates.dates.map(
          (date) =>
            `${new Date(date).getFullYear()}-${
              new Date(date).getMonth() + 1
            }-${new Date(date).getDate()}`
        )[1],
      });
    stateGroup.dates.dates.every((date) => date.length === 0) &&
      setSearchParamsState({ start_date: "", end_date: "" });
    //without dependency//
    // setStategroup({ ...stateGroup, loader: true });
    // fetchStoreDetail(searchParamsState.get("id") ? searchParamsState.get("id") : 1).then(response => {
    //     console.log("Response", response);
    //     setStategroup({ ...stateGroup, loader: false });
    // }).catch(er => {
    //     throw new Error(er);
    // }).finally(respnse => {

    // })
    //with dependency//
  };
  const handleDateChange = (date) => {
     console.log(date);
    setStategroup({
      ...stateGroup,
      dates: {
        ...stateGroup.dates,
        dates: date.map(
          (date) =>
            `${new Date(date).getFullYear()}-${
              new Date(date).getMonth() + 1
            }-${new Date(date).getDate()}`
        ),
        showCalender: !stateGroup.dates.showCalender,
      },
    });
  };
  const buildWidgets = (appName, data) => {
    
    const totalQuotes = data?.data?.[0]?.TQ?.total_quotes ?? 0  ;

    switch (appName) {
      case "Wishlist Guru":
        return [
          {
            widgettype: "Wishlist Users",
            subheading: "Total number of wishlist users",
            dataSet: { count: data.wishlist_users },
          },
          {
            widgettype: "Wishlist Items",
            subheading: "Total number of wishlist items",
            dataSet: { count: data.wishlist_items },
          },
          {
            widgettype: "Total Income",
            subheading:
              "Items added to the cart from the app is the total revenue",
            dataSet: { count: data.totalRevenue },
          },
          {
            widgettype: "Monthly Quota",
            subheading: "Monthly Quota is used",
            dataSet: {
              wishlistItems: data.wishlistItems,
              totalQuota: data.monthlyQuota,
              percentUsed: data.percentUsed,
            },
          },
        ];

      case "Quotes Guru":
        return [
          {
            widgettype: "Total Quotes",
            subheading: "Has total Quotes",
            dataSet: { count: totalQuotes },
          },
          {
            widgettype: "This Month Quotes",
            subheading: "Total number of quotes created",
            dataSet: { count: data.getCurrentMonthQuotes },
          },
          {
            widgettype: "Monthly Quota",
            subheading: "Monthly Quota is used",
            dataSet: {
              percentUsed: data.percentUsed,
            },
          },
        ];

      case "Gift-registry Guru":
        return [
          {
            widgettype: "Total Registries",
            subheading: "Total number of gift registries",
            dataSet: { count: data.total_registries ?? 0 },
          },
          {
            widgettype: "Total Registry Items",
            subheading: "Total number of items across all registries",
            dataSet: { count: data.total_registry_items ?? 0 },
          },
          {
            widgettype: "Monthly Quota",
            subheading: "Monthly quota usage",
            dataSet: { percentUsed: data.percentUsed ?? 0 },
          },
        ];

      case "Lock Guru":
        return [
          {
            widgettype: "Total Locks",
            subheading: "Total number of locks created",
            dataSet: { count: data.total_locks ?? 0 },
          },
          {
            widgettype: "Active Locks",
            subheading: "Locks with active status",
            dataSet: { count: data.active_locks ?? 0 },
          },
          {
            widgettype: "Passcode Locks",
            subheading: "Locks protected with a passcode",
            dataSet: { count: data.passcode_locks ?? 0 },
          },
        ];

      default:
        return [];
    }
  };
  useEffect(() => {
    if (stateGroup.storeDetail.shopify_plan) {
      setShopifyPlan(stateGroup.storeDetail.shopify_plan);
    }
  }, [stateGroup.storeDetail.shopify_plan]);

  useEffect(() => {
    if (stateGroup.storeDetail.review) {
      setReview(stateGroup.storeDetail.review);
    }
  }, [stateGroup.storeDetail.review]);

const refreshStoreDetails = async () => {
  setStategroup((prev) => ({ ...prev, loader: true }));

  const response = await fetchStoreDetail({
    id: searchParamsState.get("id") ? searchParamsState.get("id") : 1,
    start_: searchParamsState.get("start_date") || "",
    end_: searchParamsState.get("end_date") || "",
  });

  setStategroup((prev) => ({
    ...prev,
    loader: false,
    storeDetail: response.data.data[0],
    store_logs: response.data.store_logs,
  }));

  setTabledata((prev) => ({
    ...prev,
    tbody: modifyData(response.data.store_logs),
  }));

  setAnalyticswidget(buildWidgets(appName, response.data));
};

 const updateShopifyPlan = async () => {
  if (!shopifyPlan) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Please select a Shopify plan",
    });
    return;
  }

  try {
    setUpdatingPlan(true);

    const appName =
      window.localStorage.getItem("activeApp") || "Wishlist Guru";

    const response = await axios.post(
      "/user/storedetails/update-shopify-plan",
      {
        app_install_id: stateGroup.storeDetail.app_install_id,
        shopify_plan: shopifyPlan,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      }
    );

    setAlert({
      show: true,
      variant: "success",
      message: response.data.message,
    });
    await refreshStoreDetails();

  } catch (error) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Failed to update Shopify plan",
    });
  } finally {
    setUpdatingPlan(false);
  }
};

const updateEmailLimit = async () => {
  if (emailLimit === "" || Number(emailLimit) < 0 || Number.isNaN(Number(emailLimit))) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Please enter a valid email quota limit",
    });
    return;
  }

  try {
    setUpdatingEmailLimit(true);

    const appName = window.localStorage.getItem("activeApp") || "Wishlist Guru";

    const response = await axios.post(
      "/user/storedetails/update-email-limit",
      {
        app_install_id: stateGroup.storeDetail.app_install_id,
        email_limit: emailLimit,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      }
    );

    setAlert({
      show: true,
      variant: "success",
      message: response.data.message,
    });
    await refreshStoreDetails();
  } catch (error) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Failed to update email quota limit",
    });
  } finally {
    setUpdatingEmailLimit(false);
  }
};

const updateReview = async () => {
  if (!review || !["yes", "no"].includes(review)) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Please select a valid review value",
    });
    return;
  }

  try {
    setUpdatingReview(true);

    const appName = window.localStorage.getItem("activeApp") || "Wishlist Guru";

    const response = await axios.post(
      "/user/storedetails/update-review",
      {
        app_install_id: stateGroup.storeDetail.app_install_id,
        review: review,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "x-app-name": appName,
        },
      }
    );

    setAlert({
      show: true,
      variant: "success",
      message: response.data.message,
    });
    await refreshStoreDetails();
  } catch (error) {
    setAlert({
      show: true,
      variant: "danger",
      message: "Failed to update review",
    });
  } finally {
    setUpdatingReview(false);
  }
};

  //useEffect with dependency/
  useEffect(() => {
    // console.log("Babaji")
    // const toggleCalendar = () => {
    //     setStategroup({ ...stateGroup, dates: { ...stateGroup.dates, showCalender: false } })
    // }
    // document.addEventListener("mousedown", toggleCalendar)
    setStategroup({ ...stateGroup, loader: true });
    fetchStoreDetail({
      id: searchParamsState.get("id") ? searchParamsState.get("id") : 1,
      start_: searchParamsState.get("start_date")
        ? searchParamsState.get("start_date")
        : "",
      end_: searchParamsState.get("end_date")
        ? searchParamsState.get("end_date")
        : "",
    })
      .then((response) => {
        response &&
          setStategroup({
            ...stateGroup,
            loader: false,
            storeDetail: response.data.data[0],
            store_logs: response.data.store_logs,
          });
        setTabledata({
          ...tableData,
          tbody: modifyData(response.data.store_logs),
        });
        setAnalyticswidget(buildWidgets(appName, response.data));
      })
      .catch((er) => {
        alert(`Something went wrong , please check the respective consoles`);
        if (er) throw new Error(er);
      });
    // return () => document.removeEventListener("mousedown", toggleCalendar)
  }, [searchParamsState]);

useEffect(() => {
  if (stateGroup.storeDetail.email_limit !== undefined && stateGroup.storeDetail.email_limit !== null) {
    setEmailLimit(stateGroup.storeDetail.email_limit);
  }
}, [stateGroup.storeDetail.email_limit]);

useEffect(() => {
  if (!stateGroup.storeDetail.shop_name) return;

  const resolveUrl = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user/resolve?url=https://${stateGroup.storeDetail.shop_name}/`,
        { method: "GET", credentials: "include" }
      );

      const data = await response.json();
      setFinalUrl(data.finalUrl.replace(/\/$/, "")); // strip trailing slash

    } catch (error) {
      console.error("Error resolving URL:", error);
    }
  };

  resolveUrl();
}, [stateGroup.storeDetail.shop_name]);

useEffect(() => {
  if (!stateGroup.storeDetail.step_1  &&  !stateGroup.storeDetail.active_theme) return;
   
  const str = stateGroup.storeDetail.active_theme ? stateGroup.storeDetail.active_theme : stateGroup.storeDetail.step_1;
  const numberPart = str.includes("--") ? str.split("--")[1].trim() : str;
  setStepNumber(numberPart);
}, [stateGroup.storeDetail.step_1]);

useEffect(() => {
  if (alert.show && alert.variant === "success") {
    const timer = setTimeout(() => {
      setAlert((prev) => ({ ...prev, show: false }));
    }, 3000); 

    return () => clearTimeout(timer);
  }
}, [alert.show, alert.variant]);



  return (
    <>
    {alert.show && (
      <Alert variant={alert.variant} className="mt-3">
        {alert.message}
      </Alert>
    )}
      <Container fluid className="grid-box store-basic-details">
        <div className="header-label row p-2 grid-box-heading">
          <h3 className="page-label">Store Detail</h3>
        </div>
        <Row className="grid-box-heading detail-section-container p-2">
          <Col xs={12} className="bg-light">
             {/*<div className="p-2 d-flex align-items-center justify-content-between gap-3">*/}
            <div className="p-2">
         
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h3 className="page-label mb-0">Basic Details</h3>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() =>
                    window.open(
                      `${finalUrl}/?_ab=0&_bt=...&preview_theme_id=${stepNumber}`,
                      "_blank"
                    )
                  }
                >
                  Preview
                </Button>
              </div>

            
              <div className="d-flex align-items-end flex-wrap" style={{ gap: "20px" }}>
             
                {appName !== "Pre-order Guru" && appName !== "B2B Guru" && (
                  <div className="d-flex align-items-end" style={{ gap: "10px" }}>
                    <div className="d-grid">
                      <label
                        className="form-label mb-1"
                        style={{ color: "#f5aa33", fontWeight: 600, fontSize: "14px" }}
                      >
                        Email Quota Limit
                      </label>
                      <input
                        type="number"
                        min="0"
                        value={emailLimit}
                        onChange={(e) => setEmailLimit(e.target.value)}
                        className="rounded-2"
                        style={{
                          fontWeight: 400,
                          border: "1px solid #f5aa33",
                          minWidth: "230px",
                          height: "48px",
                          padding: "0 15px",
                          color: "#f5aa33",
                          backgroundColor: "rgb(252, 251, 251)",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>

                    <button
                      className="rounded-2"
                      disabled={updatingEmailLimit}
                      onClick={updateEmailLimit}
                      style={{
                        backgroundColor: "#f5aa33",
                        color: "#fff",
                        border: "1px solid #f5aa33",
                        fontWeight: 600,
                        height: "48px",
                        padding: "0 20px",
                        cursor: updatingEmailLimit ? "not-allowed" : "pointer",
                        opacity: updatingEmailLimit ? 0.7 : 1,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {updatingEmailLimit ? "Updating..." : "Update Limit"}
                    </button>
                  </div>
                )}

                {/* Shopify Plan */}
                <div className="d-flex align-items-end" style={{ gap: "10px" }}>
                  <div className="d-grid">
                    <label
                      className="form-label mb-1"
                      style={{ color: "#f5aa33", fontWeight: 600, fontSize: "14px" }}
                    >
                      Shopify Plan
                    </label>

                    <div
                      className="dropdown"
                      style={{
                        border: "1px solid #f5aa33",
                        borderRadius: "6px",
                        minWidth: "230px",
                        height: "48px",
                        backgroundColor: "rgb(252, 251, 251)",
                        boxSizing: "border-box",
                      }}
                    >
                      <button
                        className="dropdown-toggle d-flex justify-content-between align-items-center bg-transparent border-0 w-100 h-100"
                        data-bs-toggle="dropdown"
                        style={{
                          color: "#f5aa33",
                          padding: "0 15px",
                        }}
                      >
                        {shopifyPlan || "Select Plan"}
                      </button>

                      <div className="dropdown-menu p-2">
                        {["", "partner_test", "development", "basic", "grow", "professional", "shopify_plus", "inActive"].map(
                          (plan, idx) => (
                            <div
                              key={idx}
                              className="dropdown-item"
                              style={{
                                color: plan === shopifyPlan ? "#f5aa33" : "",
                                fontWeight: plan === shopifyPlan ? 600 : 400,
                                cursor: "pointer",
                              }}
                              onClick={() => setShopifyPlan(plan)}
                            >
                              {plan}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  <button
                    className="rounded-2"
                    disabled={updatingPlan}
                    onClick={updateShopifyPlan}
                    style={{
                      backgroundColor: "#f5aa33",
                      color: "#fff",
                      border: "1px solid #f5aa33",
                      fontWeight: 600,
                      height: "48px",
                      padding: "0 20px",
                      cursor: updatingPlan ? "not-allowed" : "pointer",
                      opacity: updatingPlan ? 0.7 : 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {updatingPlan ? "Updating..." : "Update Plan"}
                  </button>
                </div>

                {/* Review */}
                <div className="d-flex align-items-end" style={{ gap: "10px" }}>
                  <div className="d-grid">
                    <label
                      className="form-label mb-1"
                      style={{ color: "#f5aa33", fontWeight: 600, fontSize: "14px" }}
                    >
                      Review
                    </label>

                    <div
                      className="dropdown"
                      style={{
                        border: "1px solid #f5aa33",
                        borderRadius: "6px",
                        minWidth: "230px",
                        height: "48px",
                        backgroundColor: "rgb(252, 251, 251)",
                        boxSizing: "border-box",
                      }}
                    >
                      <button
                        className="dropdown-toggle d-flex justify-content-between align-items-center bg-transparent border-0 w-100 h-100"
                        data-bs-toggle="dropdown"
                        style={{
                          color: "#f5aa33",
                          padding: "0 15px",
                        }}
                      >
                        {review === "yes" ? "Yes" : "No"}
                      </button>

                      <div className="dropdown-menu p-2">
                        {["no", "yes"].map((option, idx) => (
                          <div
                            key={idx}
                            className="dropdown-item"
                            style={{
                              color: option === review ? "#f5aa33" : "",
                              fontWeight: option === review ? 600 : 400,
                              cursor: "pointer",
                            }}
                            onClick={() => setReview(option)}
                          >
                            {option === "yes" ? "Yes" : "No"}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <button
                    className="rounded-2"
                    disabled={updatingReview}
                    onClick={updateReview}
                    style={{
                      backgroundColor: "#f5aa33",
                      color: "#fff",
                      border: "1px solid #f5aa33",
                      fontWeight: 600,
                      height: "48px",
                      padding: "0 20px",
                      cursor: updatingReview ? "not-allowed" : "pointer",
                      opacity: updatingReview ? 0.7 : 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {updatingReview ? "Updating..." : "Save"}
                  </button>
                </div>
              </div>
            </div>

{/*            <div className="p-2 d-flex align-items-center" style={{justifyContent: "space-between"}}>
              <h3 className="page-label me-2">Basic Details</h3>
              <Button
                variant="primary"
                size="sm"
                onClick={() =>
                  window.open(
                    `${finalUrl}/?_ab=0&_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaU4zWldKbWNtRnRaWG90Ylc5b1lXeHBMbTE1YzJodmNHbG1lUzVqYjIwR09nWkZWQT09IiwiZXhwIjoiMjAyNS0wMy0yOFQxNToxODo1NC4yMTNaIiwicHVyIjoicGVybWFuZW50X3Bhc3N3b3JkX2J5cGFzcyJ9fQ%3D%3D--68a10c08038778aa77a60eac51388c985378d963&_fd=0&_sc=1&key=c993421149e3781c62b85dcad38e0980544e3e889ea7d157531307aeeb7b41ad&preview_theme_id=${stepNumber}`,
                    "_blank"
                  )
                }
              >
                Preview
              </Button>
            </div>*/}

            <div className="d-flex gap-2 justify-content-between w-100 p-2">
              <span className="fs-4 side-labels">
                Store Name - {stateGroup.storeDetail.store_name}
              </span>
              <span className="fs-4 side-labels">
                Active Plan - {stateGroup.storeDetail.active_plan_name} /{" "}
                {stateGroup.storeDetail.plan_type}
              </span>
            </div>
            <div className="">
              <GridList
                recordList={[...Object.entries(stateGroup.storeDetail).filter(
                  ([key]) => key !== 'TQ'
                )]}
                positive={stateGroup.loader}
              />
            </div>
          </Col>
          <Col xs={12} className="p-2 bg-light">
            <div className="p-2">
              <h3>Installation Logs</h3>
              <div className="log-list p-3 bg-white">
                <Tablelist tabledata={tableData} />
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            className="p-2 bg-light analytics-page container grid-box"
          >
            <Row className="UserListing-row p-0">
              {appName !== "Pre-order Guru" && (
                <div className="d-flex stats-label align-items-center justify-content-between col-12">
                  <h3 className="page-label w-50">Store Stats</h3>

                  <div className="d-flex align-items-center justify-content-end gap-2 w-50">
                    <div className="date-picker-container w-75 position-relative d-flex justify-content-end">
                      {stateGroup.dates.dates.some(
                        (date) => date.length > 0
                      ) ? (
                        <div
                          className="d-flex dropdown-toggle justify-content-between align-items-center  p-2 rounded-2 bg-white date-picker"
                          onClick={() =>
                            setStategroup({
                              ...stateGroup,
                              dates: {
                                ...stateGroup.dates,
                                showCalender: !stateGroup.dates.showCalender,
                              },
                            })
                          }
                        >
                          <div className="d-flex  align-items-center gap-2">
                            <div className="start-date d-flex align-items-center ">
                              <span className="label">Start - </span>
                              <span className="value">
                                {stateGroup.dates.dates[0]}
                              </span>
                            </div>
                            <div className="end-date d-flex align-items-center">
                              <span className="label">End - </span>
                              <span className="value">
                                {stateGroup.dates.dates[1]}
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="dropdown rounded-2 bg-white p-2 date-picker">
                          <div
                            className="p-0 dropdown-toggle d-flex justify-content-between align-items-center"
                            onClick={(e) =>
                              setStategroup({
                                ...stateGroup,
                                dates: {
                                  ...stateGroup.dates,
                                  showCalender: !stateGroup.dates.showCalender,
                                },
                              })
                            }
                          >
                            Select Dates
                          </div>
                        </div>
                      )}
                      {stateGroup.dates.showCalender && (
                        <div className="calendar-picker position-absolute text-muted">
                          <button
                            className="clear-dates rounded-2 px-1"
                            onClick={() =>
                              setStategroup({
                                ...stateGroup,
                                dates: {
                                  ...stateGroup.dates,
                                  dates: ["", ""],
                                  showCalender: false,
                                },
                              })
                            }
                          >
                            Clear
                          </button>
                          <Calendar
                            className={"date-calender"}
                            selectRange
                            onChange={handleDateChange}
                          />
                        </div>
                      )}
                    </div>
                    <div className="trigger-filters">
                      <button
                        onClick={babaji}
                        className="button-filter rounded-2 p-1 px-2 text-light"
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {analyticsWidget.length > 0 &&
                analyticsWidget.map((widget, index) => (
                  <Col
                    md={3}
                    className="userListing-box bg-light px-1"
                    key={index}
                  >
                    {widget.widgettype === "Monthly Quota" && (
                      <div className="userListing-box bg-white d-flex flex-column align-items-center">
                        <h3>{widget.widgettype}</h3>
                        <h2>{widget.dataSet.percentUsed}%</h2>
                        <span className="fs-6">{widget.subheading}</span>
                      </div>
                    )}
                    {widget.widgettype !== "Monthly Quota" && (
                      <div className="userListing-box bg-white">
                        <h3>{widget.widgettype}</h3>
                        <h2>{Math.ceil(widget.dataSet.count)}</h2>
                      </div>
                    )}
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default StoreDetail;